@if (isKopfdatenElement === true) {
  @if (gebaeude.gehoertZuSdr.length > 0) {
    <cap-kopfdatenelement [histInfo]="histInfo" label="gebaeude.gehoertZuSDR">
      <ng-container [ngTemplateOutlet]="sdrs"></ng-container>
    </cap-kopfdatenelement>
  }
} @else {
  @if (gebaeude.gehoertZuSdr.length > 0) {
    {{ "gebaeude.gehoertZuSDR" | translate }}
    <ng-container [ngTemplateOutlet]="sdrs"></ng-container>
  }
}
<ng-template #sdrs>
  @for (sdr of gebaeude.gehoertZuSdr | orderBySdrGrundstueckNummer; track sdr; let isLast = $last) {
    <span>
      <cap-link
        [queryParams]="{ id: sdr.id.id }"
        [target]="navigateTo"
        [tooltipParams]="{ nummer: sdr?.grundstueckNummer | grundstuecknummerExtended }">
        {{ sdr.grundstueckNummer.nummer }}{{ isLast ? "" : ", " }}
      </cap-link>
    </span>
  }
</ng-template>
